import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import Layout from './Components/Layout/Layout';
import Home from './Components/Home/Home';
import About from './Components/About/About';
import Products from './Components/Products/Products';

function App() {
  return <BrowserRouter>
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/products" element={<Products />} />
      </Routes>
    </Layout>
  </BrowserRouter>
}

export default App;
